<template>
  <div class="generation">
    <div class="generation-container--single" :class="{'generation-container--single-show-on-mobile': isUploadImageOnMobile || (generatedImage || isInOrder)}">
      <div class="generation-container" :class="{'generation-container--show-on-mobile': isUploadImageOnMobile || (generatedImage || isInOrder)}">
        <div class="generation-balance">
          {{ $t("generation.creditBalance", { balance: getMyBalance }) }}
        </div>
        <label
          :for="generatedImage === '' ? `uploadImg` : ''"
          class="generation_upload"
          @dragover.prevent
          @drop="handleDrop"
          :class="{ 'generation_upload--removed': currentImage.file }"
        >
          <!--       :style="`background-image: linear-gradient(#000000a6, #000000ab), url(${generatedImage})`"-->
          <template v-if="!isInOrder || !currentImage.src">
            <img
              v-if="currentImage.src && generatedImage === ''"
              class="generation_upload-image"
              :src="currentImage.src"
              alt="uploaded image"
            />
            <div
              v-if="!currentImage.src && generatedImage === ''"
              class="generation-container-image"
            >
              <img
                class="generation_upload-icon"
                src="@/assets/icons/upload-image.svg"
                alt="upload file image upload-some"
                draggable="false"
              />
              <h2 class="generation-container-image_title">
                {{ $t("edit.dragNDrop") }}
              </h2>
              <p class="generation-container-image_description">
                {{ $t("edit.fileSupported") }}
              </p>
            </div>
            <img
              @click="invokeZoom"
              @touchstart="invokeZoom"
              v-if="generatedImage !== ''"
              class="generation_upload-image"
              :src="generatedImage"
              alt="upload file image upload-some"
            />

            <div v-if="currentImage.src || generatedImage" class="zoom-image-buttons">
              <button
                @click="downloadImage"
                class="zoom-image-buttons_download"
              >
                <img src="@/assets/icons/download.svg" alt="download-icon">
              </button>
              <button
                @click="removeImage"
                class="zoom-image-buttons_delete"
              >
                <img src="@/assets/icons/remove.svg" alt="remove-icon">
              </button>
            </div>
          </template>
          <div class="generation-uploading" v-else>
            <img
              class="generation_upload-image"
              :src="currentImage.src"
              alt="uploaded image"
            />
            <div class="generation-uploading--background"></div>
            <LoadAnimation
              v-show="percentage >= 100"
              class="generation-uploading--loader"
            />
            <ProgressBarPercentage
              v-show="percentage < 100"
              :percentage="percentage"
            />
            <div
              v-show="percentage < 100"
              class="generation-uploading-percentage"
            >
              GENERATING NOW......
            </div>
            <div
              v-show="percentage < 100"
              class="generation-uploading-info"
            >
              Loading takes up to 1 minute
            </div>
            <div
              v-show="percentage >= 100"
              class="generation-uploading-text-after"
            >
              {{ $t("generation.almostDone") }}
            </div>
            <div
              v-show="percentage >= 100"
              class="generation-uploading-text-almost-complete"
            >
              {{ $t("generation.almostComplete") }}
            </div>
          </div>
          <input
            v-show="false"
            ref="uploadInput"
            id="uploadImg"
            type="file"
            @click="resetInput"
            @input.stop="handleFile"
            name="img"
            accept="image/*"
          />
        </label>

        <template v-if="!getSpentMoney">
          <p
            v-if="generatedImage !== '' && !isInOrder"
            class="generation-info"
          >
            Blur and watermark disappear upon purchasing Credits. <br> Buy Credits <span>Now</span> to access all AI features.
          </p>
        </template>

        <div
          class="generation-invoke-filters"
          v-if="
            generatedImage !== '' &&
            !isInOrder
          "
        >
          <button
            @click="uploadNewPhoto"
            class="generation-invoke-filters_button"
          >
            {{ $t("buttons.createNew") }}
          </button>
          <button
            @click="invokeFilters"
            class="generation-invoke-filters_button green-btn-with-pulse"
          >
            {{ $t("buttons.showFilters") }}
          </button>
          <button
            @click="handleGenerate"
            @touchstart="handleGenerate"
            class="generation-invoke-filters-cancel"
          >
            {{ $t("buttons.error_generation") }}
          </button>
        </div>
      </div>

      <div class="c-single-generation_wrapper-filters-line"></div>
      <div class="c-single-generation_wrapper-filters" :class="{'c-single-generation_wrapper-filters--mobile': isUploadImageOnMobile || (generatedImage || isInOrder)}">
        <p class="c-single-generation_wrapper-filters-title">
          Select type of <span>images</span>
        </p>

        <div
          class="c-single-generation_wrapper-filters-list"
        >
          <div
            v-for="image in images"
            :key="image.id"
            class="c-single-generation_wrapper-filters-item "
            :class="{
              'inactive': !image.isActive && !hasBalance,
              'selected': image.selected,
              'full-width': image.isCollage
            }"
            @click="handleFilter(image)"
          >
            <div v-if="image.isCollage" class="collage">
              <div class="image-holder">
                <img
                    v-for="(collageImage, index) in image.img"
                    :key="index"
                    :src="collageImage"
                    alt="collage part"
                    class="collage-item"
                />
              </div>
            </div>
            <div v-else class="image-holder">
              <img
                  :src="image.img"
                  alt="single generation content"
              />
            </div>
            <p>{{ image.title }}</p>
          </div>
        </div>
        <Button
          v-if="!isInOrderByStore && !getGeneratedImage && !(generatedImage || isInOrder)"
          class="c-single-generation_wrapper-info_button"
          @click="invokeFilters"
          :text="buttonSubmitText"
        />
      </div>
    </div>
    <GenerationSelectStepPopup
        modelName="GenerationSelectStepPopup"
        :is-open-filters="isOpenFilters"
        :breast-arr="breastArr"
        :back-types="backTypes"
        :body-types="bodyTypes"
        :ages="ages"
        :selected-type="selectedType"
        :has-one-trial="isUserHasTrialGeneration"
        @closeModal="closeFilter"
        @close="closeFilter"
        @handleGenerate="handleGenerate"
    />
    <CheckAgeTextModal v-if="isOpenAgeVerificationModal"/>
    <ZoomImage modelName="ZoomImage" @removeImage="removeImage" />
  </div>
</template>

<script>
// vue
import { computed, onUnmounted, ref, watch, onMounted, defineAsyncComponent, useTemplateRef, nextTick } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";

// utils
import { checkCookie } from "@/utils/cookies";

// i18n
import { useI18n } from "vue-i18n";

// components
import LoadAnimation from "@/components/animations/LoadAnimation.vue";
import ProgressBarPercentage from "@/components/animations/ProgressBarPercentage.vue";
import SettingsFilterPopup from "@/components/filter/SettingsFilterPopup.vue";
import ZoomImage from "@/components/modals/ZoomImage.vue";
import Button from "@/components/Button.vue";
import CheckAgeTextModal from "@/components/modals/CheckAgeTextModal.vue";

// assets
import largeTits from "@/assets/filter-girls-images/bigtits.png";
import middleTits from "@/assets/filter-girls-images/middle.png";
import smallTits from "@/assets/filter-girls-images/small.png";

import bigBody from "@/assets/filter-girls-images/fat.png";
import muscBody from "@/assets/filter-girls-images/muscular.png";
import normalBody from "@/assets/filter-girls-images/normal-body.png";
import smallBody from "@/assets/filter-girls-images/skiny-body.png";

import bigBack from "@/assets/filter-girls-images/big-dupa.png";
import mediumBack from "@/assets/filter-girls-images/medium-dupa.png";
import smallBack from "@/assets/filter-girls-images/small-dupka.png";

// assets
import bikiniImage from "@/assets/filters-bikini/black.webp";
import undressImage from "@/assets/filter-type-image/undress.png";
import breastClampImage from "@/assets/breast/woman.webp";
import cumInMouthImage from "@/assets/cumMouth/nurse.webp";
import missionaryImage from "@/assets/mission/teacher.webp";
import blowjobImage from "@/assets/bbc/nun.webp";
import GenerationSelectStepPopup from "@/components/filter/GenerationSelectStepPopup.vue";

export default {
  name: "GenerationPage",
  components: {
    GenerationSelectStepPopup,
    CheckAgeTextModal,
    ProgressBarPercentage,
    SettingsFilterPopup,
    LoadAnimation,
    ZoomImage,
    Button,
  },
  setup(props, context) {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const isUploadImageOnMobile = ref(false);
    const { t } = useI18n();
    const isOpenFilters = ref(false);
    const percentage = ref(100);
    const intervalStatus = ref(null);
    const intervalLoad = ref(null);
    const lastSelectedFilter = ref(null);
    const currentImage = ref({
      src: "",
    });
    const isOpenAgeVerificationModal = ref(false)
    const isGenerating = ref(false);
    const selectedImage = ref(null);
    const isShowRecommendationPopup = localStorage.getItem(
      "isShowRecommendationPopup"
    );

    const uploadNewPhoto = () => {
      store.dispatch("trackTraffic", 'upload_new');
      router.push('/')
    }

    const getProfileData = async () => {
      try {
        await store.dispatch("getUserProfile");
      } catch (error) {
        console.log(error)
      }
    };

    getProfileData();
    if (!isShowRecommendationPopup) {
      // store.commit("addModal", "UploadRecommendation");
    }

    const getSpentMoney = computed(() => {
      return store.getters.getSpentMoney;
    });

    const isEnoughMyBalance = computed(() => {
      return store.getters.isEnoughMyBalance;
    });

    const isActivatedProfile = computed(() => {
      return getSpentMoney.value > 0
    })

    const isInOrder = computed(() => {
      return store.getters.isInOrder;
    });
    const isInOrderByStore = computed(() => {
      return store.state.idOrder
    })

    const getGeneratedImage = computed(() => {
      return store.getters.getGeneratedImage;
    });

    const removeImage = (showPopup = false) => {
      store.dispatch("trackTraffic", 'post_reg_error');
      isOpenFilters.value = false;
      percentage.value = 0;
      currentImage.value = { src: "" };
      generatedImage.value = "";
      clearInterval(intervalStatus.value);
      clearInterval(intervalLoad.value);
      intervalStatus.value = null;
      intervalLoad.value = null;
      const fileInput = document.querySelector("#uploadImg");
      fileInput.value = "";
      store.commit("clearOrderId");
      store.commit("setGeneratedImage", "");
      isUploadImageOnMobile.value = false
      if (!showPopup) {
        store.dispatch("handleToast", {
          text: t("errors.generate.removeImg"),
          type: "WARNING",
        });
      }
    };

    const createNewImage = () => {
      removeImage();

      const fileInput = document.querySelector("#uploadImg");
      fileInput.click();
    };

    const buttonSubmitText = computed(() => {
      if (!currentImage.value.src) {
        return t('buttons.uploadImage')
      }

      if (isActivatedProfile.value) {
        return t('buttons.mainBalanced')
      }

      return t('buttons.mainRegistered')
    })

    const openPopupOver = () => {
      store.commit('addModal', 'GenerationsOverModal')
    };

    const getShowTempDesign = computed(() => {
      return store.getters.getShowTempDesign;
    });


    const getMyBalance = computed(() => {
      return store.getters.getMyBalance;
    });

    const getShowGenerationsOverModal = computed(() => {
      return store.getters.getShowGenerationsOverModal;
    });

    const hasBalance = computed(() => {
      return getSpentMoney.value > 0 || getMyBalance.value > 1;
    });

    const isUserHasTrialGeneration = computed(() => {
      return (getSpentMoney.value === 0 || getMyBalance.value === 1) && !(getMyBalance.value > 1);
    });

    const isUserDidPayment = computed(() => {
      return getMyBalance.value > 1;
    });

    const isUserAlreadyDidFreeGeneration = computed(() => {
      return getSpentMoney.value === 0 && getMyBalance.value === 0;
    });


    const handleDrop = (event) => {
      if (getShowGenerationsOverModal.value) {
        store.commit('addModal', 'GenerationsOverModal');
        return;
      }
      if (+getMyBalance.value <= 0) {
        if (getSpentMoney.value) {
          openPopupOver();
          removeImage();
          return;
        }
      }
      percentage.value = 0;
      event.preventDefault();
      const file = event.dataTransfer.files[0];

      if (file.size >= 10485760) {
        store.dispatch("handleToast", {
          text: "The image size must not exceed 10 MB.",
          type: "WARNING",
        });
        removeImage(true);
        return;
      }

      if (file && file.type.startsWith("image/")) {
        handleFile({ target: { files: [file] } });
      }
    };

    const invokeZoom = () => {
      store.commit("addModal", "ZoomImage");
    };
    const uploadInput = useTemplateRef('uploadInput')

    const invokeFilters = async () => {
      await store.dispatch("trackTraffic", 'another_pose');
      if (uploadInput.value && !currentImage.value.src) {
        uploadInput.value.click();
        return;
      }

        isOpenFilters.value = true;
        store.commit("addModal", "GenerationSelectStepPopup");
    };

    const resetInput = (event) => {
      event.target.value = null
    }

    const handleFile = (event) => {
      if (getShowGenerationsOverModal.value) {
        store.commit('addModal', 'GenerationsOverModal');
        return;
      }
      if (+getMyBalance.value <= 0) {
        if (getSpentMoney.value) {
          openPopupOver();
          // router.push({ name: "BuyCredits" });
          removeImage();
          return;
        }
      }
      if (currentImage.value.file) {
        store.dispatch("handleToast", {
          text: "Sorry, you have to remove previous image!",
          type: "WARNING",
        });
        return;
      }
      percentage.value = 0;
      const image = event.target.files[0];

      if (image.size >= 15000000) {
        store.dispatch("handleToast", {
          text: "The image size must not exceed 15 MB.",
          type: "WARNING",
        });
        removeImage(true);
        return;
      }

      currentImage.value = {
        file: image,
        src: URL.createObjectURL(image),
      };
    };

    const isValid = computed(() => {
      return !!currentImage.value.file;
    });
    const selectedType = ref(1);
    const breastArr = [
      { id: 0, title: "Small", img: smallTits, value: "small", default: false },
      { id: 1, title: "medium", img: middleTits, value: "medium", default: true },
      { id: 2, title: "large", img: largeTits, value: "large", default: false },
    ];
    const bodyTypes = [
      { id: 0, title: "slim", img: smallBody, value: "slim", default: false },
      { id: 1, title: "normal", img: normalBody, value: "normal", default: true },
      { id: 2, title: "fat", img: bigBody, value: "fat", default: false },
      { id: 3, title: "muscular", img: muscBody, value: "muscular", default: false },
    ];
    const backTypes = [
      { id: 0, title: "Small", img: smallBack, value: "small", default: false },
      { id: 1, title: "Normal", img: mediumBack, value: "medium", default: true },
      { id: 2, title: "Big", img: bigBack, value: "large", default: false },
    ];
    const ages = [
      { id: 0, title: "18", default: false },
      { id: 1, title: "20", default: true },
      { id: 2, title: "30", default: false },
      { id: 3, title: "40", default: false },
      { id: 4, title: "50", default: false },
      { id: 5, title: "60", default: false },
    ];

    const images = ref([
      {
        id: 1,
        title: "Sex Clothes",
        img: bikiniImage,
        value: "clothes",
        isActive: true,
        selected: true,
        isCollage: false,
      },
      {
        id: 2,
        title: "Undress",
        img: undressImage,
        value: "undress",
        isActive: isUserDidPayment.value,
        selected: false,
        isCollage: false,
      },
      {
        id: 3,
        title: "Sex poses",
        img: [
          blowjobImage
        ],
        isCollage: true,
        value: "sexPoses",
        isActive: isUserDidPayment.value,
        selected: false,
      },
    ]);

    const watcherTimer = ref(30000);

    const closeFilter = () => {
      isOpenFilters.value = !isOpenFilters.value;
      isGenerating.value = false;
    };

    const handleGenerate = async (filter) => {
      if (!lastSelectedFilter.value) {
        lastSelectedFilter.value = filter;
      }

      if (!filter.generation_type || !filter.character_type) {
        filter = lastSelectedFilter.value;
      }

      if (isGenerating.value) return;
      if (+getMyBalance.value <= 0) {
        if (getSpentMoney.value) {
          openPopupOver();
          removeImage();
          return;
        }
      }
      store.commit('removeAllModal')
      isGenerating.value = true;

      if (filter === "singleRequest") {
        let dummyData = {};

        if (images.value[0].selected) {
          dummyData = {
            activeTits: 1,
            activeBack: 1,
            activeAge: 0,
            activeBody: 0,
            blur: false,
          };
          isOpenAgeVerificationModal.value = true
          await justUndressRequest(dummyData).finally(() => {
            percentage.value = 0
            const timeout = setTimeout(() => {
              isOpenAgeVerificationModal.value = false
              clearTimeout(timeout);
            }, 1000);
          });
        } else if (images.value[1].selected) {
          dummyData = {
            generation_type: 'bikini',
            character_type: 'black',
            blur: false,
          };
          store.commit("setOrder", "loaded");
          isOpenAgeVerificationModal.value = true
          await inPaintRequest(dummyData).finally(() => {
            percentage.value = 0
            const timeout = setTimeout(() => {
              isOpenAgeVerificationModal.value = false
              clearTimeout(timeout);
            }, 1000);
          });
        } else if (isEnoughMyBalance.value) {
          invokeFilters();
        }
        return;
      }

      if (filter.type === "undress") {
        isOpenAgeVerificationModal.value = true
        await justUndressRequest(filter).finally(() => {
          percentage.value = 0
          const timeout = setTimeout(() => {
            isOpenAgeVerificationModal.value = false
            clearTimeout(timeout);
          }, 1000);
        });
      }

      if (filter.type === "inpaint") {
        isOpenAgeVerificationModal.value = true

        await inPaintRequest(filter).finally(() => {
          percentage.value = 0
          const timeout = setTimeout(() => {
            isOpenAgeVerificationModal.value = false
            clearTimeout(timeout);
          }, 1000);
        });
      }

      if (filter.type === "poses") {
        // if (getSpentMoney.value >= 5) {
        isOpenAgeVerificationModal.value = true
        await posesRequest(filter).finally(() => {
          percentage.value = 0
          const timeout = setTimeout(() => {
            isOpenAgeVerificationModal.value = false
            clearTimeout(timeout);
          }, 1000);
        });
        // } else {
        //   store.commit('addModal', 'InfoAboutPremiumContent')
        //   isGenerating.value = false
        //   store.commit('clearOrderId')
        // }
      }
    };

    const justUndressRequest = async (filter) => {
      try {
        const formData = new FormData();
        formData.append("image", currentImage.value.file);
        formData.append(
          "breast_size",
          breastArr.find((element) => element.id === filter.activeTits || element.default).value
        );

        formData.append(
          "butt_size",
          backTypes.find((element) => element.id === filter.activeBack || element.default).value
        );
        formData.append(
          "age",
          ages.find((element) => element.id === filter.activeAge || element.default).title
        );
        formData.append(
          "body_type",
          bodyTypes.find((element) => element.id === filter.activeBody || element.default).value
        );

        if (filter.blur) {
          formData.append('blur', "True");
        }

        for (let [key, value] of formData.entries()) {
          // todo remove

          console.log(`formData entry - ${key}: ${value}`);
        }

        isOpenFilters.value = false;

        const response = await store.dispatch("generateGirl", formData);
        // const response = {}
        if (
          response.name === "AxiosError" ||
          response.message === "Network Error"
        ) {
          openPopupOver();

          // router.push({ name: "BuyCredits" });
          removeImage();
          return;
        }

        createWatcher();
        createLoadWatcher();
        await store.dispatch("getUserProfile");
      } catch (error) {
        console.error("Ошибка при генерации justUndressRequest:", error);
        removeImage();
      } finally {
        isGenerating.value = false;
      }
    };

    const inPaintRequest = async (filter) => {
      try {
        const formData = new FormData();
        formData.append("image", currentImage.value.file);
        formData.append("generation_type", filter.generation_type);
        formData.append("character_type", filter.character_type);

        if (filter.blur) {
          formData.append('blur', "True");
        }

        isOpenFilters.value = false;
        const response = await store.dispatch("generateInPaintGirl", formData);
        for (let [key, value] of formData.entries()) {
          // todo remove
          console.log(`inPaintRequest formData entry - ${key}: ${value}`);
        }

        console.log('inPaintRequest response', response)
        if (
          response.name === "AxiosError" ||
          response.message === "Network Error"
        ) {
          openPopupOver();

          // router.push({ name: "BuyCredits" });
          removeImage();
          return;
        }

        createWatcher();
        createLoadWatcher();
        await store.dispatch("getUserProfile");
      } catch (error) {
        console.error("Ошибка при генерации inPaintRequest:", error);
        removeImage();
      } finally {
        isGenerating.value = false;
      }
    };

    const posesRequest = async (filter) => {
      try {
        const formData = new FormData();
        formData.append("image", currentImage.value.file);
        formData.append("generation_type", filter.generation_type);
        formData.append("character_type", filter.character_type);

        isOpenFilters.value = false;
        const response = await store.dispatch("generatePosesGirl", formData);
        for (let [key, value] of formData.entries()) {
          // todo remove

          console.log(`posesRequest formData entry - ${key}: ${value}`);
        }
        // const response = {}
        if (
          response.name === "AxiosError" ||
          response.message === "Network Error"
        ) {
          openPopupOver();

          // router.push({ name: "BuyCredits" });
          removeImage();
          return;
        }

        createWatcher();
        createLoadWatcher();
        await store.dispatch("getUserProfile");
      } catch (error) {
        console.error("Ошибка при генерации posesRequest:", error);
        removeImage();
      } finally {
        isGenerating.value = false;
      }
    };

    const zoomImage = () => {
      store.commit("addModal", "ZoomImage");
    };

    const filterModal = () => {
      store.commit("addModal", "SettingsFilterPopup");
    };

    const createLoadWatcher = () => {
      if (percentage.value >= 100) {
        clearInterval(intervalLoad.value);
        percentage.value = 0;
      }

      intervalLoad.value = setInterval(async () => {
        percentage.value = percentage.value + 1;
        if (percentage.value >= 100) {
          clearInterval(intervalLoad.value);
          intervalLoad.value = null;
        }
      }, 600);
    };

    const createWatcher = () => {
      if (intervalStatus.value) {
        clearInterval(intervalStatus.value);
      }

      intervalStatus.value = setInterval(async () => {
        const response = await store.dispatch("checkStatus");
        const guideSeen = checkCookie('guideSeen')

        if (watcherTimer.value === 30000) {
          watcherTimer.value = 10000;
          clearInterval(intervalStatus.value);
          createWatcher();
        }

        if (response && response.image_url) {
          clearInterval(intervalStatus.value);
          intervalStatus.value = null;
          store.commit("clearOrderId");
          watcherTimer.value = 30000;
          percentage.value = 0;

          !guideSeen ? router.push({ name: "GenerationResult" }) : "";
        }
      }, watcherTimer.value);
    };

    const generatedImage = computed(() => {
      return store.getters.getGeneratedImage;
    });

    const handleFilter = (image) => {
      if (image.id === 3) {
        store.dispatch("trackTraffic", 'another_pose');
      }
      if (!image.isActive && !isUserAlreadyDidFreeGeneration.value) {
        store.dispatch("handleToast", {
          text: "This pose is available only for registered users with credits. Buy credits Now to use all features",
          type: "WARNING",
        });
        return;
      }

      selectedType.value = image.id;
      if (window.innerWidth <= 950 && currentImage.value.src === '') {
        document.querySelector('#uploadImg').click();
        isUploadImageOnMobile.value = true
      }
      images.value.forEach(item => {
        item.selected = false;
      });
      image.selected = true;
    };

    const downloadImage = async (event) => {
      try {
        const response = await fetch(generatedImage.value);
        const blob = await response.blob();

        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "downloaded_image.png";
        link.click();
        URL.revokeObjectURL(link.href);
      } catch (error) {
        console.error("Ошибка при скачивании изображения:", error);
      }
    };

    watch(isOpenFilters, (newValue) => {
      if (newValue) {
        document.body.classList.add("no-scroll");
      } else {
        document.body.classList.remove("no-scroll");
      }
    });

    watch(isActivatedProfile, (newVal) => {
      for (let i = 2; i < images.value.length; i++) {
        images.value[i].isActive = newVal
      }
    }, { immediate: true })

    onMounted( async () => {
      if (generatedImage.value) {
        generatedImage.value = "";
        removeImage(true);
      }
      await store.dispatch("getUserProfile");

      if (isUserHasTrialGeneration.value) {
        store.commit('addModal', 'SuccessRegistrationModal')
      }

      if (isUserAlreadyDidFreeGeneration.value) {
        store.commit('addModal', 'GenerationsOverModal')
      }

      images.value = images.value.map(img => {
        if ([2, 3].includes(img.id)) {
          return { ...img, isActive: isUserDidPayment.value };
        }
        return img;
      });
    });

    onUnmounted(() => {
      if (intervalStatus.value) {
        clearInterval(intervalStatus.value);
      }
    })

    return {
      resetInput,
      handleDrop,
      handleFile,
      zoomImage,
      handleGenerate,
      downloadImage,
      closeFilter,
      removeImage,
      createNewImage,
      uploadNewPhoto,
      invokeZoom,
      invokeFilters,
      buttonSubmitText,
      getMyBalance,
      percentage,
      isOpenFilters,
      generatedImage,
      isActivatedProfile,
      isInOrder,
      currentImage,
      isOpenAgeVerificationModal,
      isInOrderByStore,
      breastArr,
      isUploadImageOnMobile,
      backTypes,
      bodyTypes,
      isEnoughMyBalance,
      getGeneratedImage,
      ages,
      images,
      selectedImage,
      handleFilter,
      selectedType,
      getSpentMoney,
      hasBalance,
      isUserHasTrialGeneration,
      isUserAlreadyDidFreeGeneration,
      openPopupOver,
      getShowTempDesign,
      lastSelectedFilter,
      getShowGenerationsOverModal,
      isUserDidPayment,
    };
  },
};
</script>

<style lang="scss" scoped>
.collage {
  overflow: hidden;
  margin-bottom: 6px;

  //&:hover {
  //  border: 3px solid #ACF601;
  //  border-radius: 20px;
  //}

  &-item {
    border-radius: 20px;
    overflow: hidden;
    height: 181px !important;
    object-fit: cover;

    @media screen and (max-width: 950px) {
      height: 380px !important;
    }
  }
}

.collage img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}


.generation {
  align-items: flex-start;
  justify-content: space-between;
  height: 100%;
  grid-gap: 20px;
  width: 100%;
  padding: 0 40px;

  @media screen and (max-width: 768px) {
    padding: 0 10px;
  }

  &-balance {
    margin-bottom: 29px;
    color: #ACF601;
    text-align: center;
    font-size: 40px;
    font-style: normal;
    font-weight: 800;
    line-height: 100%;
    text-transform: capitalize;

    @media screen and (max-width: 1024px) {
      margin-bottom: 15px;
      font-size: 24px;
    }

    @media screen and (max-width: 768px) {
      font-size: 24px;
    }
    @media screen and (max-width: 480px) {
      font-size: 16px;
    }
  }
  &-text {
    text-align: center;
    font-size: 24px;
    font-weight: 700;
    margin: 10px auto 20px auto;
  }
  &-container {
    display: flex;
    align-items: center;
    // justify-content: space-between;
    flex-direction: column;
    border: 2px solid #ACF601;
    background: #2C2B2B;
    border-radius: 30px;
    // max-height: 724px;
    max-width: 1043px;
    margin: 0 auto 30px auto;
    padding: 29px 45px 25px;

    @media screen and (max-width: 1024px) {
      padding: 15px;
      // min-height: 550px;
    }

    &-image {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      &_title {
        text-transform: uppercase;
        color: #ffffff;
        opacity: 0.85;
        margin-top: 5px;
        @media screen and (max-width: 1024px) {
          font-size: 16px;
        }
        @media screen and (max-width: 550px) {
          font-size: 14px;
        }
      }
      &_description {
        margin-top: 5px;
        @media screen and (max-width: 550px) {
          font-size: 12px;
          text-align: center;
        }
      }
    }
  }
  &_upload {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-items: center;
    width: 100%;
    height: 700px;
    max-height: calc(100% - 147px);
    background: #808080;
    background-size: 120%;
    border-radius: 20px;
    position: relative;
    margin-bottom: 22px;

    @media screen and (max-width: 550px) {
      width: 100%;
      max-width: 100%;
      padding: 0;
      min-height: 250px;
      height: 400px;
    }

    &--removed {
      cursor: progress;
      border: none;
      border-radius: 8px;
      overflow: hidden;
      max-height: 500px;
    }

    &-icon {
      margin: 0 auto;
      @media screen and (max-width: 550px) {
        width: 40%;
      }
      &-done {
        width: 75%;
        margin: 0 auto;
        cursor: zoom-in;
        z-index: 4;
        @media screen and (max-width: 550px) {
          width: 100%;
        }
      }
    }
    &-image {
      margin: 0 auto;
      width: 100%;
      height: 100%;
      object-fit: cover;

      @media screen and (max-width: 420px) {
        height: 400px;
      }
    }
  }
  &-uploading {
    position: relative;
    width: 100%;
    margin: 0 auto;
    word-spacing: 2px;
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 15px;
    justify-content: center;
    height: 100%;
    line-height: 1.8;
    overflow: hidden;
    border-radius: 8px;
    @media screen and (max-width: 1024px) {
      min-height: 400px;
    }
    &-info {
      width: 588px;
      max-width: 100%;
      height: 31px;
      flex-shrink: 0;
      color: #ACF601;
      text-align: center;
      font-size: 40px;
      font-style: normal;
      font-weight: 700;
      line-height: 100%;
      text-transform: capitalize;
      position: absolute;
      bottom: 63px;
      left: 50%;
      transform: translateX(-50%);

      @media screen and (max-width: 1440px) {
        font-size: 30px;
        bottom: 43px;
      }
      @media screen and (max-width: 1150px) {
        font-size: 24px;
        bottom: 40px;
      }

      @media screen and (max-width: 768px) {
        font-size: 20px;
        bottom: 35px;
      }

      @media screen and (max-width: 480px) {
        font-size: 16px;
        bottom: 30px;
      }
    }
    &-percentage {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      color: #FFF;
      text-align: center;
      font-size: 40px;
      font-style: normal;
      font-weight: 800;
      line-height: 100%;
      text-transform: capitalize;
      white-space: nowrap;

      @media screen and (max-width: 1024px) {
        font-size: 24px;
      }

      @media screen and (max-width: 768px) {
        font-size: 20px;
      }

      @media screen and (max-width: 480px) {
        font-size: 16px;
      }
    }
    &-text-almost-complete {
      width: 588px;
      height: 31px;
      flex-shrink: 0;
      color: #ACF601;
      text-align: center;
      font-size: 40px;
      font-style: normal;
      font-weight: 700;
      line-height: 100%;
      position: absolute;
      top: 20px;
      left: 50%;
      transform: translateX(-50%);

      @media screen and (max-width: 1500px) {
        max-width: 80%;
        font-size: 24px;
        line-height: 27px;
      }

      @media screen and (max-width: 1024px) {
        font-size: 24px;
        top: 10px;
      }

      @media screen and (max-width: 768px) {
        font-size: 20px;
        top: 8px;
      }

      @media screen and (max-width: 480px) {
        font-size: 16px;
        top: 4px;
      }
    }
    &-text-after {
      width: 588px;
      height: 31px;
      flex-shrink: 0;
      color: #ACF601;
      text-align: center;
      font-size: 40px;
      font-style: normal;
      font-weight: 700;
      line-height: 100%;
      text-transform: capitalize;
      position: absolute;
      bottom: 25px;
      left: 50%;
      transform: translateX(-50%);

      @media screen and (max-width: 1024px) {
        font-size: 24px;
        bottom: 10px;
      }

      @media screen and (max-width: 768px) {
        font-size: 20px;
        bottom: 8px;
      }

      @media screen and (max-width: 480px) {
        font-size: 16px;
        bottom: 4px;
      }
    }
    &--loader {
      position: absolute !important;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      @media screen and (max-width: 550px) {
        //transform: scale(0.7);
        //left: 43%;
      }
      @media screen and (max-width: 460px) {
        //left: 35%;
      }
    }
    &--background {
      background-color: rgba(0, 0, 0, 0.4);
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
    }
    .generation_upload-image {
      filter: blur(3px);
    }
  }
  &-info {
    width: 100%;
    max-width: 668px;
    flex-shrink: 0;
    color: #FFF;
    text-align: center;
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%;
    text-transform: capitalize;
    margin-bottom: 30px;

    @media screen and (max-width: 1024px) {
      font-size: 20px;
      margin-bottom: 20px;
    }

    @media screen and (max-width: 768px) {
      font-size: 16px;
      margin-bottom: 15px;
    }

    span {
      text-transform: uppercase;
    }
  }
  &-invoke-filters {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 25px;
    justify-content: center;
    margin-bottom: 15px;
    width: 100%;

    @media screen and (max-width: 650px) {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 20px;
      max-width: 100%;
      width: 100%;
    }

    &_button {
      cursor: pointer;
      border: none;
      min-width: 258px;
      box-shadow: 1px 2px 10px #67eb00;
      outline: none;
      transition: all 0.3s;
      border-radius: 20px;
      background: #ACF601;
      height: 71px;
      color: #000;
      text-align: center;
      font-size: 26px;
      font-style: normal;
      font-weight: 700;
      line-height: 100%;
      text-transform: capitalize;
      &:hover {
        box-shadow: 1px 2px 25px #67eb00;
        color: rgba(0, 0, 0, 1);
      }
      &--disabled {
        opacity: 0.55;
        cursor: not-allowed;
      }

      @media screen and (max-width: 1440px) {
        font-size: 20px;
        height: 45px;
        border-radius: 10px;
        min-width: 100%;
      }
      @media screen and (max-width: 1024px) {
        font-size: 20px;
        height: 45px;
        border-radius: 10px;
      }

      @media screen and (max-width: 768px) {
        font-size: 16px;
        height: 40px;
        border-radius: 8px;
      }

      @media screen and (max-width: 650px) {
        width: 100%;
      }
    }
    &-cancel {
      grid-column-start: 1;
      grid-column-end: 3;
      border: none;
      min-width: 258px;
      border-radius: 20px;
      background: #963333;
      box-shadow: 1px 2px 10px rgb(222, 8, 47);
      cursor: pointer;
      outline: none;
      transition: all 0.3s;
      height: 71px;
      color: #fff;
      text-align: center;
      font-size: 26px;
      font-style: normal;
      font-weight: 700;
      line-height: 100%;
      text-transform: capitalize;
      white-space: pre-wrap;
      &--once {
        min-width: 258px;
      }
      &:hover {
        box-shadow: 1px 2px 25px rgb(222, 8, 47);
      }
      &--disabled {
        filter: grayscale(1);
        color: #f5f5f59e;
      }

      @media screen and (max-width: 1440px) {
        font-size: 20px;
        height: 45px;
        border-radius: 10px;
        min-width: 100%;
      }

      @media screen and (max-width: 1024px) {
        font-size: 20px;
        height: 45px;
        border-radius: 10px;
        white-space: initial;
      }

      @media screen and (max-width: 768px) {
        font-size: 16px;
        height: 40px;
        border-radius: 8px;
      }

      @media screen and (max-width: 650px) {
        width: 100%;
      }
    }
    &-download {
      border: none;
      background-color: rgba(0, 122, 255, 0.9);
      height: 40px;
      font-size: 18px;
      min-width: 210px;
      border-radius: 8px;
      box-shadow: 1px 2px 10px rgba(0, 122, 255, 0.9);
      cursor: pointer;
      outline: none;
      transition: all 0.3s;
      &--once {
        min-width: 240px;
      }
      &:hover {
        box-shadow: 1px 2px 25px rgba(0, 122, 255, 0.9);
      }
      &--disabled {
        filter: grayscale(1);
        color: #f5f5f59e;
      }

      @media screen and (max-width: 1024px) {
        font-size: 20px;
        height: 50px;
        border-radius: 10px;
      }

      @media screen and (max-width: 768px) {
        font-size: 16px;
        height: 40px;
        border-radius: 8px;
      }

      @media screen and (max-width: 650px) {
        width: 100%;
      }
    }
  }
  &_filters {
    overflow: auto;
    height: 100%;
    position: fixed;
    right: -2000px;
    top: 0;
    transition: all 0.75s;
    background-color: rgba(10, 10, 10, 0.95);
    border-radius: 8px 8px 0 0;
    padding: 10px 25px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 0;

    &--active {
      width: 25vw;
      max-width: 25vw;
      height: 100vh;
      z-index: 300;
      right: 0;
      @media screen and (max-width: 1920px) {
        width: 40vw;
        max-width: 40vw;
      }
      @media screen and (max-width: 950px) {
        padding-bottom: 80px;
        width: 100%;
        max-width: 100%;
      }
      @media screen and (max-width: 550px) {
        padding-bottom: 80px;
      }
    }

    &-holder {
      display: flex;
      flex-direction: column;
      &_head {
        display: flex;
        justify-content: space-between;
        align-items: center;
        &-icon {
          cursor: pointer;
        }
      }
      @media screen and (max-width: 900px) {
        margin-bottom: 5px;
      }
    }

    &-profile {
      display: block;
      text-align: left;
      width: 100%;
      margin: 0 auto;
      padding-bottom: 15px;
      border-bottom: 1px solid rgba(245, 245, 245, 0.56);
    }
    &-option {
      display: flex;
      align-items: flex-start;
      flex-direction: column;
      margin-bottom: 10px;
      margin-top: 10px;
      &-age {
        margin-top: 20px;
      }
      &-wrapper {
        display: flex;
        align-items: center;
        margin-top: 10px;
        gap: 10px;
        flex-wrap: wrap;
        &-age {
          display: flex;
          align-items: center;
          margin-top: 10px;
          gap: 10px;
          flex-wrap: wrap;
        }
      }
      &_item {
        width: 120px;
        min-height: 158px;
        border-radius: 8px;
        text-transform: capitalize;
        display: flex;
        flex-direction: column;
        cursor: pointer;
        background-color: rgba(25, 25, 25, 0.95);
        border: 1px solid rgba(0, 0, 0, 0);
        box-shadow: 1px 2px 10px #000;
        overflow: hidden;
        position: relative;
        &-poses-card {
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 14px;
          width: 135px;
          border-radius: 8px;
        }
        &:hover {
          border: 1px solid #b4f12f;
        }
        &--active {
          background-color: #b4f12f;
          color: #000;
          .generation_filters-option_item-description {
            color: #000;
          }
        }
        &-age {
          border: 1px solid #b4f12f;
          border-radius: 50%;
          padding: 10px 10px;
          text-transform: capitalize;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
        }
        &-description {
          padding: 10px 15px;
          font-weight: 700;
          text-align: center;
          &-image {
            height: 127px;
            object-fit: cover;
            width: 100%;
            border-radius: 8px 8px 0 0;
          }
        }
        &-vip {
          width: 35px;
          height: 35px;
          position: absolute;
          right: 0;
          top: 0;
          background-color: rgba(27, 27, 27, 0.95);
          border-radius: 0 0 0 12px;
          padding: 5px;
          display: flex;
          align-items: center;
          justify-content: center;
          &-icon {
            width: 20px;
            height: 20px;
            margin-bottom: 5px;
          }
        }
      }
    }
    &_footer {
      display: flex;
      align-items: center;
      gap: 20px;
      div {
        width: 50%;
        cursor: pointer;
      }
    }
    &-pagination {
      position: relative;
      margin: 5px 0;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 10px;
      .swiper-button-lock {
        display: block;
      }
      &-arrow {
        color: white;
        width: 25px;
        height: 25px;
        margin-top: 0;
        position: relative;
        right: auto;
        left: auto;
        &::after {
          font-size: 22px;
        }
      }
      &_left {
      }
      &_right {
      }
    }
  }

  .zoom-image-buttons {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    margin-top: 15px;
    position: absolute;
    gap: 15px;
    top: 10px;
    left: 20px;

    button {
      width: 30px;
      height: 30px;
      padding: 3px;
      border: none;
      background-color: hsla(0, 0%, 58.8%, .5);
      border-radius: 5px;
      cursor: pointer;
    }

    img  {
      width: 100%;
      object-fit: cover;
      height: 100%;
      max-height: 700px;
    }
  }
}

.generation-container--single {
  display: grid;
  grid-template-columns: 1fr 1px 500px;
  max-width: 1600px;
  margin: 0 auto;
  padding: 30px;
  gap: 40px;

  @media screen and (max-width: 1020px) {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    height: 100%;
    margin-top: 25px;
    margin-bottom: 25px;
  }

  .generation-container {
    max-width: 100%;
    height: 100%;
    width: 100%;
    margin: 0 40px 0 20px;

    &-image {
      padding: 20px;
    }
  }

  .generation_upload {
    height: 100%;
    max-height: initial;
  }

  @media screen and (max-width: 1440px) {
    grid-template-columns: 1fr 1px 1fr;

    .generation-container {
      width: 100%;
      max-width: 500px;
      margin: 0 auto;
      padding: 20px;
      height: auto;
    }
  }
  @media screen and (max-width: 1030px) {
    grid-template-columns: 2fr 1px 1fr;
    padding: 10px;
    gap: 10px;

    .c-single-generation_wrapper-filters-line {
      display: none;
    }

    .generation-container {
      width: 100%;
      margin: 0 auto;
      height: 100%;
      max-width: 500px;
    }
  }

  @media screen and (max-width: 950px) {
    &-show-on-mobile {
      display: flex;
      flex-direction: column !important;
    }
    .generation-container {
      display: none;
      &--show-on-mobile {
        display: block !important;
        margin-bottom: 10px;
      }
    }
  }

  @media screen and (max-width: 550px) {
    padding: 0;
  }
}

.c-single-generation {
  &_wrapper {
    display: flex;
    align-items: flex-start;
    padding-left: 20px;
    padding-right: 20px;
    gap: 3vw;
    justify-content: space-between;
    width: 100%;
    margin: 0 auto;

    @media screen and (max-width: 1024px) {
      &:not(.wrapper-filters) {
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
      }
      &.wrapper-filters {
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
      }
    }

    &-info {
      width: 80%;
      max-width: 460px;
      padding-top: 40px;
      display: flex;
      flex-direction: column;
      flex-grow: 0;
      gap: 30px;

      @media screen and (max-width: 1100px) {
        justify-content: center;
        align-items: center;
        text-align: center;
        width: 100%;
      }

      &-headline {
        font-size: 48px;
        color: #FFF;
        font-style: normal;
        font-weight: 600;
        line-height: 110%;
        letter-spacing: -1.92px;
        text-align: center;
        text-transform: capitalize;
        span {
          color: #b4f12f;
        }
        @media screen and (max-width: 950px) {
          font-size: 36px;
        }
      }
      &_button {
        width: 100%;

        :deep(button) {
          width: 100%;
          height: 60px;
          border-radius: 20px;
          font-size: 18px;
        }
      }
    }

    &-image-holder {
      width: 80%;
      height: 100%;
      // max-width: 500px;
      padding-top: 40px;
      display: flex;
      flex-direction: column;
      flex-grow: 0;
      gap: 30px;

      @media screen and (max-width: 1100px) {
        justify-content: center;
        align-items: center;
        text-align: center;
        width: 100%;
      }

      &-item {
        height: 820px;
        padding: 40px;
        border-radius: 30px;
        background: #3E3E3E;
        display: flex;
        align-items: center;
        justify-content: center;

        @media screen and (max-width: 768px) {
          padding: 20px;
        }

        img {
          width: 100%;
        }
      }
    }

    &-right {
      position: relative;
      width: 80%;
      display: flex;
      flex-wrap: wrap;
      padding-top: 40px;
      flex-grow: 1;
      @media screen and (max-width: 550px) {
        width: 100% !important;
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    &-filters {
      position: relative;
      width: 100%;
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 20px;
      max-width: 420px;
      margin: 0 auto;

      @media screen and (max-width: 1040px) {
        width: 100% !important;
        max-width: 330px;
        min-width: 330px;
      }

      @media screen and (max-width: 950px) {
        &--mobile {
          .c-single-generation_wrapper-filters-list {
            order: 3;
          }
          .c-single-generation_wrapper-filters-title {
            order: 2;
          }
          .c-single-generation_wrapper-info_button {
            order: 1;
          }
        }
      }

      &-title {
        color: #FFF;
        text-align: center;
        font-size: 36px;
        font-style: normal;
        font-weight: 700;
        line-height: 100%;
        text-transform: capitalize;

        @media screen and (max-width: 768px) {
          font-size: 28px;
        }

        @media screen and (max-width: 550px) {
          font-size: 24px;
        }

        span {
          color: #b4f12f;
        }
      }

      &-list {
        display: flex;
        flex-wrap: wrap;
        gap: 20px;
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      &-line {
        height: 100%;
        width: 1px;
        background: #ACF601;
        @media screen and (max-width: 1020px) {
          display: none;
        }
      }

      &-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: calc(50% - 10px);
        cursor: pointer;

        &.inactive {
          .image-holder {
            position: relative;

            &::before {
              content: "";
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              background-image: url("../assets/img/stripes.png");
              background-size: 100% 100%;
              background-repeat: no-repeat;
              background-position: center;
              z-index: 1;
            }
          }
        }

        &.selected {
          .image-holder {
            border: 3px solid #ACF601;
          }
        }

        .image-holder {
          overflow: hidden;
          border-radius: 20px;
          background: #FFF;
          width: 100%;
          height: 181px;
          margin-bottom: 6px;

          @media screen and (min-width: 1024px) {
            &:hover {
              border: 3px solid #ACF601;
            }
          }

          @media screen and (max-width: 950px) {
            height: 380px;
          }

          @media screen and (max-width: 768px) {
            height: 260px;
          }

          @media screen and (max-width: 550px) {
            height: 220px;
          }
          @media screen and (max-width: 375px) {
            height: 160px;
          }

          img {
            width: 100%;
            height: 100%;
          }
        }

        p {
          color: #FFF;
          text-align: center;
          font-size: 32px;
          font-style: normal;
          font-weight: 700;
          line-height: 100%;
          text-transform: capitalize;

          @media screen and (max-width: 768px) {
            font-size: 28px;
          }

          @media screen and (max-width: 550px) {
            font-size: 24px;
          }
        }
      }
      @media screen and (max-width: 950px) {
        width: 100% !important;
        max-width: 100%;
        min-width: 90%;
      }
    }

    &.wrapper-filters {
      display: grid;
      grid-template-columns: 1fr 2px 1fr;
      padding-top: 40px;

      .c-single-generation_wrapper-image-holder {
        width: 100%;
        height: 100%;
        padding-top: 0;
      }

      @media screen and (max-width: 1100px) {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;

        .c-single-generation_wrapper-image-holder {
          display: block;
          width: 100%;
          height: 100%;
          padding-top: 0;

          &-item {
            height: 80vw;
            min-height: 400px;
          }
        }
      }
    }

    &-footer {
      &_desc {
        p {
          color: #FFF;
          text-align: center;
          font-size: 22px;
          font-style: normal;
          font-weight: 600;
          line-height: 100%;
          text-transform: capitalize;
          span {
            color: #b4f12f;
          }
        }
      }
    }
  }
  &_card-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 40px;
    @media screen and (max-width: 1100px) {
      gap: 20px;
      justify-content: center;
    }
    @media screen and (max-width: 825px) {
      display: flex;
      flex-direction: column;
      width: 100%;
    }
    &_item {
      backdrop-filter: blur(48px);
      &:nth-child(2) {
        margin: 0 20px;
      }
      @media screen and (max-width: 825px) {
        width: 90%;
      }
    }
  }
}
</style>
